// eslint-disable-next-line simple-import-sort/imports
import * as React from 'react';
import { Link } from '@gjensidige/builders-components';

export function GdprComponentSe() {
  const gdprText = 'Läs om hur vi behandlar personuppgifter';
  return (
    <Link
      target="_blank"
      rel="noopener noreferrer"
      href={'/om-oss/gdpr'}
      icon={false}
    >
      {gdprText}
    </Link>
  );
}

export default GdprComponentSe;
